import type { Permission, PermissionDocument, PermissionTypes } from '../../@types/Permission';

export interface PermissionResolved {
  enabled: boolean;
  document?: PermissionDocument;
}

export const resolvePermission = (
  permissions: Permission | undefined,
  permission: PermissionTypes,
): PermissionResolved | undefined => {
  if (!permissions) return undefined;
  return {
    enabled: !!permissions?.permissions.find((x) => x === permission),
    document: permissions?.messages.documents.find((x) => x.permission === permission),
  };
};
